export type TaxRule = {
  _id: string;
  country: string;
  state: string;
  stateCode: string;
  county: string;
  countyCode: string;
  zipCodes: string[];
  taxRate: number;
  comments: string;
  status: string;
};

export type TaxGroup = {
  id: string;
  name: string;
  tax_rules: TaxRule[];
  status: string;
};

const jsonOrThrow = async (res: Response) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok || (data && (data.error || data.message))) {
    throw new Error(data.error || data.message || `HTTP ${res.status}`);
  }
  return data;
};

export async function fetchTaxGroups(token: string): Promise<TaxGroup[]> {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/tax-groups`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  return jsonOrThrow(res);
}

export async function fetchTaxRules(token: string): Promise<TaxRule[]> {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/tax-rules`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  return jsonOrThrow(res);
}
